<template>
    <div>
        <Header></Header>
        <div class="activityCon">
            <Lottie :options="defaultOptions" :width="500" :height="500" class="lottie"></Lottie>
        </div>
    </div>
</template>
<script>
import Header from '../../components/Header.vue'
import Lottie from '../../components/lottie.vue'
import temp from '../../assets/lottie/lottiedemo.json'
export default{
  components:{
      Header,
      Lottie
  },
  data() {
    return {
        defaultOptions:{animationData:temp,loop:true,autoplay:true}
    }
  }
}
</script>
<style scoped>
.activityCon{
    width: 100%;
    height: 100vh;
    background-color: #000;
    color: #fff;
    text-align: center;
    /* line-height: 100vh; */
}
.lottie:hover{
    transform: scale(1.3);
    transition: all 0.3s linear;
}
</style>


// WEBPACK FOOTER //
// src/view/pc/Activity.vue